import {
  Box,
  Typography,
  Select,
  MenuItem
} from "@mui/material";
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const CustomLocationSelectField = () => {
  return (
    <Box>
      {/* Label */}
      <Typography
        sx={{
          fontSize: "13px",
          color: "#aaa",
          mb: 0.5,
        }}
      >
        Location
      </Typography>

      {/* Select */}
      <Select
        defaultValue="newyork"
        variant="standard"
        disableUnderline
        IconComponent={KeyboardArrowDownIcon}
        sx={{
          color: "#fff",
          minWidth: "180px",

          "& .MuiSelect-icon": {
            color: "#ffffff", // purple arrow
          },

          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: 0,
          },
        }}
        MenuProps={{
  PaperProps: {
    sx: {
      backgroundColor: "#000",
      color: "#fff",
      "& .MuiMenuItem-root": {
        "&:hover": {
          backgroundColor: "#1a1a1a",
        },
      },
    },
  },
}}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <FmdGoodIcon sx={{ color: "#a020f0" }} />
            <Typography sx={{ color: "#fff" }}>
              India
            </Typography>
          </Box>
        )}
      >        
        <MenuItem value="mumbai">India</MenuItem>
      </Select>
    </Box>
  );
};

export default CustomLocationSelectField;
